import React, { useContext, useRef } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useHistory } from 'react-router-dom';

import { compose } from '@xo-union/react-css-modules';
import { Snackbar } from '@xo-union/tk-component-alerts';

import { SnackbarInterface, DISMISS_TIMEOUT } from '../../../helpers/snackbar';
import { ButtonDropdown, ButtonDropdownItem } from '../../ButtonDropdown';
import { messagingHubRoute } from '../../../helpers/routes';
import { TrackingContext } from '../../../TrackingContext';
import styles from './previewHeader.scss';

interface ShareButtonProps {
  url: string;
  size?: string;
  trackSource: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({ url, trackSource, size }) => {
  const dropDownItemStyles = compose({ itemLink: styles.itemLink });
  const { track } = useContext(TrackingContext);
  const history = useHistory();
  const snackbar = useRef<SnackbarInterface>();

  const onCopyLink = () => {
    track('Website Link Copied', {
      source: trackSource,
    });
    if (snackbar?.current) {
      snackbar.current.showAndDismiss({
        data: 'Website link copied',
        dismissTimeout: DISMISS_TIMEOUT,
      });
    }
  };

  const onMessageGuests = () => {
    track('Message Guests Clicked', {
      source: trackSource,
    });
    history.push(messagingHubRoute);
  };

  return (
    <div className={styles.shareButtonWrapper}>
      <Snackbar ref={snackbar} />
      <ButtonDropdown
        size={size || 'md'}
        color="secondary"
        icon="arrow_down"
        showDropIcon="arrow_up"
        text={
          <>
            <span className={styles.desktopCopy}>Share website</span>
            <span className={styles.mobileCopy}>Share</span>
          </>
        }
        carrotPosition="center"
        className={styles.shareWebsiteButton}
        data-testid="eip-share-website-btn"
      >
        <CopyToClipboard text={url} onCopy={onCopyLink}>
          <ButtonDropdownItem
            key={1}
            title="Copy link"
            icon="copy"
            subText="Text, DM or email guests a link to your website"
            classes={dropDownItemStyles}
            data-testid="eip-copy-link-btn"
          />
        </CopyToClipboard>
        <ButtonDropdownItem
          key={2}
          onClick={onMessageGuests}
          title="Message guests"
          icon="send"
          subText="Use a template to share your site by email or text"
          classes={dropDownItemStyles}
          data-testid="eip-message-guests-btn"
        />
      </ButtonDropdown>
    </div>
  );
};

export default ShareButton;
